define('views/modules/questionnaire/questions/list/options/options-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/parts/form/button',
    // models
    'models/questionnaire/option',
    // templates
    'text!templates/modules/questionnaire/questions/list/options/options-list.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VButton,
    // models
    MOption,
    // templates
    TOptionsList
) {

    var VOptionsList = VList.extend({
        template: TOptionsList,

        regions: _.extend({}, VList.prototype.regions, {
            root: ".list-content",
            list: '.list-items',
            addOption: ".add-option"
        }),

        initialize: function(options) {
            VOptionsList.__super__.initialize.call(this, options);

            this.view = {
                addOption: new VButton({ label: "questionnaire:Add option", callback: this.onAddOptionClick, icon: "sl-icon-plus", context: this, block: true }),
            };

        },

        render: function() {
            VOptionsList.__super__.render.call(this);

            this.assign(this.view.addOption, this.zone.$addOption);

            this.toggle(this.model.isOptionsEnabled());

            this.resetList();

            return this;
        },

        toggle: function(val) {
            var zone = this.zone;
            if (zone) zone.$root.toggleClass('hidden', !val);
        },

        onAddOptionClick: function(e) {
            this.collection.add(new MOption());
        },

    });

    return VOptionsList;

});

